export const ADD_TO_CART = 'ADD_TO_CART';
export const CHECKOUT_REQUEST = 'CHECKOUT_REQUEST';
export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS';
export const CHECKOUT_FAILURE = 'CHECKOUT_FAILURE';
export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js